export default "/_next/static/images/modal-edge-texture-3597c6c28a603428a769ba900c7ae619.svg";